<template>
  <div class="modalTable">
    <vxe-toolbar fixed="top">
      <template v-slot:buttons>
        <el-button @click="funcFilter">
          查询
        </el-button>
        <el-button @click="clearRadioRowEevnt">
          取消选中
        </el-button>
        <el-button type="primary" @click="getRadioEvent">
          获取选中
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable1"
      height="80%"
      border
      :radio-config="{ highlight: true }"
      :loading="loading"
      :data="tableData"
      @radio-change="radioChangeEvent"
    >
      <vxe-table-column type="radio" width="60" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="partyType"
          :formatter="formatterPartyType"
          title="用户类型"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.partyType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in partyTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="name" min-width="100" title="姓名" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="请输入姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="phone" min-width="150" title="手机号码" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入手机号"
            clearable
          />
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import { selectParty } from "@/api/InternetBanking";
import { regMerPartyInfo } from "@/api/merchantCenter";
export default {
  name: "Child",
  data() {
    return {
      loading: false,
      formData: {},
      listQuery: {
        name: "",
        phone: "",
        partyType: "",
        fromScenes: "allowRegArpaParty", //查询允许注册网商商户的用户
        pageNum: 1,
        pageSize: 20,
        total: 0,
        status: 0,
        regMerchant: 0
      },
      Pagingconf: [],
      tableData: [],
      options: [
        {
          value: "driver",
          label: "实际承运人"
        },
        {
          value: "shipment",
          label: "托运人"
        }
      ],
      partyTypeOptions: [
        { label: "平台管理员", value: "PLAT_ADMIN" },
        { label: "车队长", value: "DRIVER_LEADER" },
        { label: "实际承运人", value: "DRIVER" },
        { label: "托运人子账号", value: "SHIPMENT" },
        { label: "托运人", value: "SHIPMENT_COMPANY" }
      ],
      partyData: {}
    };
  },
  computed: {
    branchList() {
      return this.$store.state.components.branchList;
    }
  },
  watch: {
    "$store.state.components.branchList": function() {
      this.$refs.xTable.updateData();
    }
  },
  created() {
    this.shipmentlist();
  },
  methods: {
    //查询代发托运人
    shipmentlist() {
      this.loading = true;
      selectParty(this.listQuery).then(response => {
        this.tableData = response.data.records;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
        this.listQuery.total = response.data.total;
        this.loading = false;
      });
    },
    //获取选中
    getRadioEvent() {
      let data = this.$refs.xTable1.getRadioRecord();
      regMerPartyInfo(data.code).then(res => {
        this.$emit("event1", res.data);
      });
    },
    //取消选中
    clearRadioRowEevnt() {
      this.selectRow = null;
      this.$refs.xTable1.clearRadioRow();
    },
    //选中事件
    radioChangeEvent({ row }) {
      this.selectRow = row;
    },
    // 查询
    funcFilter() {
      this.listQuery.pageNum = 1;
      this.shipmentlist();
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.shipmentlist();
    },
    formatterPartyType({ cellValue }) {
      const item = this.partyTypeOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>
